export const SECOND_PARENT_STATUS = {
  single: 'single',
  paternity: 'paternity',
  widowed: 'widowed',
  divorced: 'divorced'
};

export const DEAD_PARENT = {
  hasDeathCert: 'hasDeathCert',
  courtDecision: 'courtDecision'
};
